import { takeLatest, put, call } from 'redux-saga/effects';
import { CORE_API } from '../../../../config';
import request from '../../../../components/Utils/httpHelper';
import { HTTP_HEADERS } from '../../../../constants';
import {
    responseOfUnprocessedData,
    REQUEST_FOR_UNPROCESSED_DATA_FOR_LEGAL_MODERATION,
    POST_PROCESSED_LEGAL_DATA_TO_SERVER,
    responseOfpostProcessedDataToServer,
    responseOfUnprocessedAdditionalLegalData,
    REQUEST_FOR_UNPROCESSED_DATA_FOR_ADDITIONAL_LEGAL_MODERATION,
    POST_PROCESSED_ADDITIONAL_LEGAL_DATA_TO_SERVER,
    DOWNLOAD_LEGAL_BULK_DELETE_TEMPLATE,
    UPLOAD_LEGAL_BULK_DELETE_EXCEL,
    responseOfUploadBulkDeleteExcel,
    responseOfpostProcessedAdditionalLegalDataToServer,
    SET_EXCEL_DOWNLOADING  
} from './action';
import { func } from 'prop-types';

export function* fetchUnprocessedData(action) {
    let requestURL = `${CORE_API}/legal/api/leagl-unprocessed-data/LEGAL/${action.data}`;
     try {
        const result = yield call(request, requestURL, { method: 'GET',  headers: HTTP_HEADERS } );
        yield put(responseOfUnprocessedData({data : result.data, status : result.status}));
    } catch (err) {
        yield put(responseOfUnprocessedData({...err.response.data, status  : err.response.status}))
    } 
}

export function* watchDownloadBulkDeleteTemplate() {
    yield takeLatest(DOWNLOAD_LEGAL_BULK_DELETE_TEMPLATE, downloadBulkDeleteTemplate);
}

export function* watchUploadBulkDeleteExcel() {
    yield takeLatest(UPLOAD_LEGAL_BULK_DELETE_EXCEL, uploadBulkDeleteExcel);
}

export function* fetchUnprocessedLegalData() {
    yield takeLatest(REQUEST_FOR_UNPROCESSED_DATA_FOR_LEGAL_MODERATION, fetchUnprocessedData);
}

export function* postProcessedData(action) {
    let requestURL = `${CORE_API}/legal/api/legal-processed-data/${action.data.corporateId}`;
     try {
        const result = yield call(request, requestURL, { method: 'POST', data : action.data.data,  headers: HTTP_HEADERS } );
        yield put(responseOfpostProcessedDataToServer({ response : result.data, status : result.status}));
    } catch (err) {
        yield put(responseOfpostProcessedDataToServer({ ...err.response.data, status  : err.response.status}))
    } 
}

export function* postProcessedDataToServer(){
    yield takeLatest(POST_PROCESSED_LEGAL_DATA_TO_SERVER, postProcessedData);
}

//additional Legal
export function* fetchUnprocessedDataforAdditionalLegal(action) {
    let requestURL = `${CORE_API}/legal/api/leagl-unprocessed-data/ADDITIONAL_LEGAL/${action.data}`;
     try {
        const result = yield call(request, requestURL, { method: 'GET',  headers: HTTP_HEADERS } );
        yield put(responseOfUnprocessedAdditionalLegalData({data : result.data, status : result.status}));
    } catch (err) {
        yield put(responseOfUnprocessedAdditionalLegalData({...err.response.data, status  : err.response.status}))
    } 
}

export function* fetchUnprocessedAdditionalLegalData() {
    yield takeLatest(REQUEST_FOR_UNPROCESSED_DATA_FOR_ADDITIONAL_LEGAL_MODERATION, fetchUnprocessedDataforAdditionalLegal);
}

export function* postProcessedAdditionalLegalData(action) {
    let requestURL = `${CORE_API}/legal/api/legal-processed-data/${action.data.corporateId}`;
     try {
        const result = yield call(request, requestURL, { method: 'POST', data : action.data.data,  headers: HTTP_HEADERS } );
        yield put(responseOfpostProcessedAdditionalLegalDataToServer({ response : result.data, status : result.status}));
    } catch (err) {
        yield put(responseOfpostProcessedAdditionalLegalDataToServer({ ...err.response.data, status  : err.response.status}))
    } 
}

export function* postProcessedAdditionalLegalDataToServer(){
    yield takeLatest(POST_PROCESSED_ADDITIONAL_LEGAL_DATA_TO_SERVER, postProcessedAdditionalLegalData);
}

export function* downloadBulkDeleteTemplate(action) {
    let requestURL = `${CORE_API}/legal/api/legal-cases/download/${action.counterpartyId}`;
    try {
                yield put({ type: SET_EXCEL_DOWNLOADING, payload: true });

        const response = yield call(fetch, requestURL, {
            method: 'GET',
            headers: HTTP_HEADERS
        });
        
        const blob = yield response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Legal_Bulk_Delete_Template_${action.counterpartyId}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        yield put({ type: SET_EXCEL_DOWNLOADING, payload: false });


    } catch (err) {
        console.error("Template download failed", err);
                 yield put({ type: SET_EXCEL_DOWNLOADING, payload: false });
        toast.error("Failed to download template. Please try again.");

    }
}

export function* uploadBulkDeleteExcel(action) {
    
    const counterpartyId = action.data.get("counterpartyId");

    let requestURL = `${CORE_API}/legal/api/legal-cases/bulk-delete-from-excel/${counterpartyId}`;
    
    try {
        const uploadHeaders = { ...HTTP_HEADERS };
        delete uploadHeaders['Content-Type']; 

        const result = yield call(request, requestURL, { 
            method: 'POST', 
            data: action.data, 
            headers: uploadHeaders 
        });
        
        yield put(responseOfUploadBulkDeleteExcel({ 
            status: "Success", 
            message: result.data.message 
        }));

    } catch (err) {
        yield put(responseOfUploadBulkDeleteExcel({ 
        status: "Failure",
        message: err.response?.data?.message || err.response?.data || "Internal Server Error",
        httpStatus: err.response?.status || 500 
    }));
    }
}